export const SmsExpeditorThingTypeMrn = "mrn:sl2:::smsExpeditor";

export enum SmsExpeditorSuppliers {
  TWILIO = "twilio",
  SOMUM = "somum",
}
